import { api, tokens } from './client';

export interface AuthUser {
  id: string;
  email: string;
  referralCode: string;
  role: 'USER' | 'ADMIN';
  emailVerifiedAt: string | null;
}

export interface AuthResponse {
  user: AuthUser;
  accessToken: string;
  refreshToken: string;
}

export const authApi = {
  signup: (data: { email: string; password: string; referralCode?: string }) =>
    api<{ message: string; user: { id: string; email: string; referralCode: string } }>(
      '/api/auth/signup',
      { method: 'POST', body: data, skipAuth: true },
    ),

  login: async (data: { email: string; password: string }) => {
    const res = await api<AuthResponse>('/api/auth/login', {
      method: 'POST',
      body: data,
      skipAuth: true,
    });
    tokens.set(res.accessToken, res.refreshToken);
    return res;
  },

  logout: async () => {
    try {
      await api('/api/auth/logout', { method: 'POST' });
    } finally {
      tokens.clear();
    }
  },

  verifyEmail: (token: string) =>
    api<{ message: string }>('/api/auth/verify-email', {
      method: 'POST',
      body: { token },
      skipAuth: true,
    }),

  requestPasswordReset: (email: string) =>
    api<{ message: string }>('/api/auth/forgot-password', {
      method: 'POST',
      body: { email },
      skipAuth: true,
    }),

  resetPassword: (data: { token: string; newPassword: string }) =>
    api<{ message: string }>('/api/auth/reset-password', {
      method: 'POST',
      body: data,
      skipAuth: true,
    }),

  me: () => api<AuthUser>('/api/me'),
};
